import React from 'react'

import Avatar from '@mui/material/Avatar'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

import { Icon } from '@mxenabled/mxui'

interface DataRowProps {
  iconName: string
  label: string
  onClick?: () => void
  showChevron?: boolean
  value: string
}

const DataRow: React.FC<DataRowProps> = ({
  iconName,
  label,
  onClick,
  showChevron = true,
  value,
}) => {
  const rowContents = (
    <>
      <ListItemAvatar>
        <Avatar sx={{ bgcolor: 'neutral.light' }} variant="rounded">
          <Icon name={iconName} sx={{ color: 'text.primary' }} />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={label}
        secondary={value}
        slotProps={{
          primary: { variant: 'caption', fontWeight: 'normal' },
          secondary: { color: 'text.default', variant: 'body1', fontWeight: 600 },
        }}
      />
    </>
  )

  return onClick ? (
    <ListItem disableGutters={true} disablePadding={true}>
      <ListItemButton onClick={onClick}>
        {rowContents}
        {showChevron && (
          <ListItemIcon>
            <Icon name="chevron_right" size={24} />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  ) : (
    <ListItem disableGutters={false} disablePadding={false}>
      {rowContents}
    </ListItem>
  )
}

export default DataRow
